import React from "react"
import styled, { css } from "styled-components"
import { AppFunctionComponent } from "../../types"

const lineWidth = 3

const hamburgerInnerStyle = css<{ isDark?: boolean }>`
  width: 40px;
  height: ${lineWidth}px;
  background-color: ${({ theme, isDark }) =>
    isDark ? "white" : theme.color.text};
  border-radius: 4px;
  position: absolute;
  transition-property: transform;
  transition-duration: 0.15s;
  transition-timing-function: ease;
`

const sliderInnerStyle = css`
  top: 2px;
`
const sliderInnerBeforeStyle = css`
  top: 10px;
  transition-property: transform, opacity;
  transition-timing-function: ease;
  transition-duration: 0.15s;
`
const sliderInnerAfterStyle = css`
  top: 20px;
`

const activeInnerStyle = css`
  transform: translate3d(0, 10px, 0) rotate(45deg);
`
const activeInnerBeforeStyle = css`
  transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);
  opacity: 0;
`
const activeInnerAfterStyle = css`
  transform: translate3d(0, -20px, 0) rotate(-90deg);
`

const HamburgerInner = styled.span<{ isDark?: boolean }>`
  display: block;
  top: 50%;
  margin-top: -2px;
  ${hamburgerInnerStyle};
  ${sliderInnerStyle};
  &:after,
  &:before {
    ${hamburgerInnerStyle};
    content: "";
    display: block;
  }
  &:before {
    ${sliderInnerBeforeStyle};
    top: 10px;
  }
  &:after {
    ${sliderInnerAfterStyle};
    bottom: -10px;
  }
`

const activeStyles = css`
  ${HamburgerInner} {
    ${activeInnerStyle};
    &:before {
      ${activeInnerBeforeStyle};
    }
    &:after {
      ${activeInnerAfterStyle};
    }
  }
`

const HamburgerButton = styled.button<{ active: boolean }>`
  cursor: pointer;
  padding: 6px 0 0;
  transform: scale(0.6);
  display: inline-block;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
  outline: none;
  ${({ active }) => active && activeStyles};
`

const HamburgerBox = styled.span`
  width: 40px;
  height: 24px;
  display: inline-block;
  position: relative;
`

interface Props {
  active: boolean
  onClick?: () => void
  isDark?: boolean
}

const Hamburger: AppFunctionComponent<Props> = ({
  className,
  active,
  onClick,
  isDark,
}) => {
  return (
    <HamburgerButton
      className={className}
      active={active}
      onClick={onClick}
      aria-label={active ? "Close menu" : " Open menu"}
    >
      <HamburgerBox>
        <HamburgerInner isDark={isDark} />
      </HamburgerBox>
    </HamburgerButton>
  )
}

export default Hamburger
